<div class="crop-modal-container">
  <div class="crop-modal-header">
    <span class="crop-modal-title">Adjust Profile Photo</span>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <div class="crop-modal-body">
    <image-cropper
      [imageBase64]="imageBase64"
      [maintainAspectRatio]="true"
      [aspectRatio]="1"
      [roundCropper]="true"
      [transform]="transform"
      output="base64"
      format="jpeg"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded($event)"
      (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"
    ></image-cropper>
  </div>
  <div class="crop-modal-toolbar">
    <button type="button" class="btn btn-tool" title="Rotate left" (click)="rotateLeft()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="1 4 1 10 7 10"></polyline>
        <path d="M3.51 15a9 9 0 1 0 .49-3.81"></path>
      </svg>
      Rotate Left
    </button>
    <button type="button" class="btn btn-tool" title="Rotate right" (click)="rotateRight()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="23 4 23 10 17 10"></polyline>
        <path d="M20.49 15a9 9 0 1 1-.49-3.81"></path>
      </svg>
      Rotate Right
    </button>
    <button type="button" class="btn btn-tool" title="Flip horizontal" (click)="flipHorizontal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="17 1 21 5 17 9"></polyline>
        <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
        <polyline points="7 23 3 19 7 15"></polyline>
        <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
      </svg>
      Flip H
    </button>
    <button type="button" class="btn btn-tool" title="Flip vertical" (click)="flipVertical()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="23 7 19 3 15 7"></polyline>
        <path d="M13 21H11a4 4 0 0 1-4-4V3"></path>
        <polyline points="1 17 5 21 9 17"></polyline>
        <path d="M11 3h2a4 4 0 0 1 4 4v14"></path>
      </svg>
      Flip V
    </button>
  </div>
  <div class="crop-modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="apply()">Apply</button>
  </div>
</div>
